var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{attrs:{"href":_vm.fbAuthURL}},[_vm._v("Facebook")]),_c('a',{attrs:{"href":_vm.googleAuthURL}},[_vm._v("Google")])])}
var staticRenderFns = []

export { render, staticRenderFns }